export default function FooterSection() {
  return (
    <footer className="w-full bg-[#2c3338] text-white px-8 md:px-20 py-16">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-10">

        {/* ================= BRAND + SOCIAL (NOW FIRST ON MOBILE) ================= */}
        <div className="order-1 md:order-2">
          <div className="flex items-center gap-3 mb-3">
            <img
              src="/chat.png"
              alt="Candid Stitch Logo"
              className="w-10 h-10 object-contain"
            />
            <h2 className="text-3xl font-bold tracking-wide">
              Candid Stitch
            </h2>
          </div>

          <p className="text-gray-300 mb-6 text-sm">
            We are available on
          </p>

          <div className="flex gap-4 items-center">
           <a
  href="https://www.instagram.com/candidstitch/?hl=en&redirect_to_browser=true"
  target="_blank"
  rel="noopener noreferrer"
  className="hidden lg:block"
>
  <img
    src="/instagram.png"
    className="w-10 h-10 object-contain"
    alt="Instagram"
  />
</a>




            <a href="https://www.linkedin.com/company/candid-stitch" target="_blank" rel="noreferrer">
              <img src="/linkedin.png" className="w-10 h-10 object-contain" />
            </a>
            <a href="https://wa.me/918080907304" target="_blank" rel="noreferrer">
              <img src="/whatsapp.png" className="w-10 h-10 object-contain" />
            </a>
            <a href="https://www.indiamart.com/candid-stitch" target="_blank" rel="noreferrer">
              <img src="/indiamart.png" className="w-10 h-10 object-contain" />
            </a>
          </div>
        </div>

        {/* ================= LEFT CONTACT INFO (NOW SECOND ON MOBILE) ================= */}
        <div className="space-y-3 md:space-y-8 order-2 md:order-1">


          {/* Address */}
          <div className="flex items-start gap-4">
            <a
              href="https://maps.app.goo.gl/p63nz2SyyxiHmnAa9?g_st=aw"
              target="_blank"
              rel="noreferrer"
              className="w-12 h-12 rounded-full bg-white/10 flex items-center justify-center"
            >
              <img src="/location.png" alt="Location" className="w-6 h-6" />
            </a>

            <a
              href="https://maps.app.goo.gl/p63nz2SyyxiHmnAa9?g_st=aw"
              target="_blank"
              rel="noreferrer"
              className="text-lg hover:text-orange-400 transition"
            >
              <p>Candid Stitch ,Sadhana Apartment, 1222,</p>
              <p>Perugate, Sadashiv Peth, Pune,</p>
              <p>Maharashtra 411030</p>
            </a>
          </div>

          {/* Phone */}
          <div className="flex items-center gap-4">
            <a
              href="tel:+918080907304"
              className="w-12 h-12 rounded-full bg-white/10 flex items-center justify-center"
            >
              <img src="/call.png" alt="Call" className="w-6 h-6" />
            </a>

            <a
              href="tel:+918080907304"
              className="text-lg hover:text-orange-400 transition"
            >
              +91 8080907304
            </a>
          </div>

          {/* Email */}
          <div className="flex items-center gap-4">
            <a
              href="mailto:candidstitch2025@email.com"
              target="_blank"
              rel="noopener noreferrer"
              className="w-12 h-12 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 transition"
            >
              <img src="/mail.png" alt="Mail" className="w-6 h-6" />
            </a>

            <a
              href="mailto:candidstitch2025@email.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-400 hover:text-blue-300 transition"
            >
              candidstitch2025@email.com
            </a>
          </div>
        </div>

        {/* ================= FOOTER LINKS (UNCHANGED) ================= */}
        <div className="order-3">
          <h3 className="text-lg font-semibold mb-4">Quick Links</h3>

          <ul className="space-y-3 text-gray-300">
            <li>
              <a href="/" className="hover:text-white transition">
                Home
              </a>
            </li>

            <li>
              <a href="/products" className="hover:text-white transition">
                All Products
              </a>
            </li>

            <li>
              <a href="https://wa.me/918080907304" className="hover:text-white transition">
                Contact us
              </a>
            </li>
          </ul>
        </div>

      </div>

      {/* ================= BOTTOM BAR ================= */}
      <div className="border-t border-white/10 mt-14 pt-6 text-gray-400 text-sm text-center">
        © {new Date().getFullYear()} Candid Stitch. All rights reserved.
      </div>
    </footer>
  );
}
